import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { URLBunge, c_pathname } from "./Componentes/Config";
import { LogAcesso, ReactHtmlParser } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  ImgNoticia,
  DivBtsNoticiaNovidades,
  TituloNoticiaDescricao,
  BtVoltar,
  TextoDescNews
} from './Estilos'

import ImgBtSetaVoltar from "./Images/BtSeta.png";

function NoticiaDescricao(props) {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(true);
  const IdNoticia = document.location.pathname.substr(1).toLowerCase().split("/")[2];


  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));

  useEffect(() => {

    // console.log('passou', window.location.href);
    // console.log('passou', document.location.pathname.substr(1).toLowerCase().split("/")[2]);
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Notícias")
        PegaNoticias();
    }
  }, []);

  const [TipoSelecionado, setTipoSelecionado] = useState(0);
  function MudaPesquisa(Tipo) {
      setTipoSelecionado(Tipo)
      if(Tipo === 0){
        LogAcesso(Token, "Noticias")
      } else {
        LogAcesso(Token, "Novidades")
      }
  }

  const [ UrlImageNews, setUrlImageNews ] = useState("");
  const [ TituloNews, setTituloNews ] = useState("");
  const [ itemId, setItemId ] = useState("");
  const [ DescricaoNews, setDescricaoNews ] = useState("");
  const [ TextoNews, setTextoNews ] = useState("");
  const [ noticiasTipoId, setNoticiasTipoId ] = useState("");

  async function PegaNoticias() {
    

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "bearer " + Token);
        
        var requestOptions = {
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow'
        };
        
        fetch(URLBunge + '/api/Noticias/ListarNoticiasPoId/' + IdNoticia, requestOptions)
          .then(response => response.json())
          .then(result => {
            // console.log(result);
  
            if(result.sucesso === true) {
                setLoading(false)
                setItemId(result.id);
                setUrlImageNews(result.caminho);
                setTituloNews(result.titulo);
                setDescricaoNews(result.descricao);
                setTextoNews(result.texto);
                setNoticiasTipoId(result.noticiasTipoId);
            }
  
          })
          .catch(error => console.log('error', error));
  
    
  }


  console.log('passou',props.location.state);

  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>
        {/* <BackgroundImg Background={BgRegras} BackgroundMob={BgRegras} bgcolor={'#3c647d'}> */}

            
            <ColunaRegras>
                <div className={'AreaColunaRegras'}>

                    <TitNoticias>Notícias e Novidades</TitNoticias>

                    <DivBtsNoticiaNovidades>
                    <BtVoltar onClick={ ()=> history.push({ pathname: '/noticias', state: {} }) }> <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div></BtVoltar>
                    </DivBtsNoticiaNovidades>
                    <Clear />
                    
                    <TituloNoticiaDescricao>{TituloNews}</TituloNoticiaDescricao>
                    <Clear />
                    
                    {UrlImageNews !== "" ? <ImgNoticia src={`https://www.plataformaomnion.com.br/UploadsImagens/AppBunge/Noticias/${UrlImageNews}`} /> : null}
                    <Clear />

                    <TextoDescNews>{TextoNews}</TextoDescNews>


                </div>  
            </ColunaRegras>
            
            <MenuPrinc Pagina="Noticias" />
         </BackgroundImg>
    </>
  );

}

export default NoticiaDescricao;
